interface ILayoutProperty {
  type: 'boolean'
  defaultValue?: unknown
  description?: string
}

interface ILayoutSettingsProperties {
  [key: string]: 'boolean' | ILayoutProperty
}

export interface ILayoutSettings {
  name: string
  template: string
  properties: ILayoutSettingsProperties
}

export const mapLayoutSettingProperty = (
  property?: ILayoutSettingsProperties[string]
): ILayoutProperty | null => {
  if (!property) {
    return null
  }
  if (typeof property === 'string') {
    return {
      type: 'boolean',
    }
  }
  return property
}
